
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import classNames from "classnames/bind";
import { FiX, FiCheckCircle, FiClock, FiUser } from "react-icons/fi";
import styles from "./ExamDetailPopup.module.scss";

import { getExamByIdUser } from '../../redux/apiRequest';

const cx = classNames.bind(styles);

const formatDuration = (seconds) => {
    if (!Number.isFinite(seconds) || seconds <= 0) return "Không xác định";
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes} phút`;
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return remainingMinutes === 0 ? `${hours} giờ` : `${hours} giờ ${remainingMinutes} phút`;
};

const formatDate = (dateStr) => {
    if (!dateStr) return "—";
    const date = new Date(dateStr);
    return date.toLocaleString("vi-VN");
};



function ExamDetailPopup({ user, dispatch, axiosJWT, exam, onClose }) {
    const examState = useSelector((state) => state.exams.exambyid);

    const examdata_assigned_users = useMemo(() => {
        if (!Array.isArray(examState?.data?.assigned_users)) return [];
        return examState.data.assigned_users;
    }, [examState]);

    useEffect(() => {
        if (user?.accessToken && exam?.id) {
            getExamByIdUser(user.accessToken, dispatch, axiosJWT, exam.id);
        }
    }, [user?.accessToken, dispatch, axiosJWT, exam?.id]);

    // ✅ Đặt sau hook
    if (!exam) return null;

    console.log(examdata_assigned_users);

    return (
        <div className={cx("overlay")}>
            <div className={cx("popup")}>
                <button className={cx("close-btn")} onClick={onClose} aria-label="Đóng">
                    <FiX size={20} />
                </button>

                <header className={cx("header")}>
                    <h2>{examState.data?.title ?? "Không rõ tên"}</h2>
                    <div className={cx("duration")}>
                        <FiClock /> {formatDuration(examState.data?.duration_seconds)}
                    </div>
                </header>

                <section className={cx("users-section")}>
                    <h3>Danh sách thí sinh</h3>
                    {Array.isArray(examdata_assigned_users) && examdata_assigned_users.length > 0 ? (
                        <ul className={cx("user-list")}>
                            {examdata_assigned_users.map((u, idx) => (
                                <li key={idx} className={cx("user-item")}>
                                    <span className={cx("user-id")}>
                                        <FiUser /> {u.fullname}
                                    </span>
                                    <span
                                        className={cx("status", {
                                            submitted: u.has_submitted,
                                            pending: !u.has_submitted,
                                        })}
                                    >
                                        {u.has_submitted ? (
                                            <FiCheckCircle className={cx("icon")} />
                                        ) : (
                                            <FiClock className={cx("icon")} />
                                        )}
                                        {u.has_submitted ? "Đã nộp" : "Chưa nộp"}
                                    </span>
                                    <span className={cx("submitted-at")}>
                                        {formatDate(u.submitted_at)}
                                    </span>
                                    <span className={cx("correct-count")}>
                                        Đúng: {u.correct_count ?? "—"}
                                    </span>
                                    <span className={cx("score")}>
                                        Điểm: {u.score !== null ? u.score : "—"}
                                    </span>
                                </li>
                            ))}

                        </ul>
                    ) : (
                        <p className={cx("empty")}>Chưa có thí sinh nào nộp bài.</p>
                    )}
                </section>
            </div>
        </div>
    );
}


export default ExamDetailPopup;
